exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes Lock_fadeIn__1scXQ {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes Lock_fadeIn__1scXQ {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes Lock_fadeOut__2lRAQ {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes Lock_fadeOut__2lRAQ {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.Lock_lock__10J5t {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  margin: auto; }\n  .Lock_lock__10J5t .Lock_badge__1q3Qw {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n    -webkit-align-items: center;\n            align-items: center;\n    -webkit-justify-content: center;\n            justify-content: center;\n    width: 90px;\n    height: 90px;\n    border-radius: 50px;\n    margin: auto;\n    font-size: 35px;\n    color: #adadad;\n    background-color: #f4f8f9; }\n  .Lock_lock__10J5t .Lock_label__1r4Up {\n    font-size: 12px;\n    color: #adadad;\n    margin-top: 10px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"lock": "Lock_lock__10J5t",
	"badge": "Lock_badge__1q3Qw",
	"label": "Lock_label__1r4Up",
	"fadeIn": "Lock_fadeIn__1scXQ",
	"fadeOut": "Lock_fadeOut__2lRAQ"
};